import {
  gnenumEDGE as EDGE
} from './gnenum.js'

const gnedgeIdCreatePart = tuple => tuple[2]
  ? `[${tuple[0]}].${tuple[1]}.${tuple[2]}`
  : `[${tuple[0]}].${tuple[1]}`

// construct human-useful edge id serializing relationship
// ```
// [/addtodo/selectall].subj.total►[/datausers].subj.childlength
// ```
const gnedgeIdCreate = (sendertuple, targettuple) =>
  [sendertuple, targettuple]
    .map(gnedgeIdCreatePart).join('►')

const gnedgeCreate = (sendertuple, targettuple) => ([
  EDGE,
  gnedgeIdCreate(sendertuple, targettuple),
  [sendertuple, targettuple]
])

const gnedgeIdGet = edge => edge[1]
const gnedgeMetaGet = edge => edge[2]
const gnedgeMetaSenderGet = edge => edge[2][0]
const gnedgeMetaSenderKeyGet = edge => edge[2][0][0]
const gnedgeMetaTargetGet = edge => edge[2][1]
const gnedgeMetaTargetKeyGet = edge => edge[2][1][0]

const gnedgeMetaOptsSet = (edge, opts) => (
  edge[2][1].push(opts),
  edge)

const gnedgeIsSame = (edgea, edgeb) => (
  edgea[1] === edgeb[1])

export {
  gnedgeCreate,
  gnedgeIsSame,
  gnedgeMetaGet,
  gnedgeMetaOptsSet,
  gnedgeMetaSenderGet,
  gnedgeMetaSenderKeyGet,
  gnedgeMetaTargetGet,
  gnedgeMetaTargetKeyGet,
  gnedgeIdGet,
  gnedgeIdCreatePart,
  gnedgeIdCreate
}
